import styles from './styles.module.scss';
import classNames from 'classnames';

export const MainPageCard = ({ disabled = false, onClick, icon, title }) => {
  return (
    <div
      className={classNames(styles.card, { [styles.disabled]: disabled })}
      onClick={() => {
        !disabled && onClick();
      }}
    >
      {icon}
      {title}
      {disabled && <p className={styles.subtitle}>Coming soon</p>}
    </div>
  );
};
